import { trpc } from '@/lib/trpc';

const useGetLists = () => {
	const { data, isLoading, error } = trpc.list.get.useQuery(undefined, {
		refetchOnMount: false,
	});

	return {
		lists: data?.lists || [],
		listsLoading: isLoading,
		listsError: error,
	};
};

export default useGetLists;
